// // working just for qr auth i have to below code bec due to login allow to go to other page

// import React, { useEffect } from 'react'
// import { Route, Routes, useNavigate } from 'react-router-dom'
// import Layout from '../Components/Layout/Layout'
// import Login from './Login'
// import ProductList from './Product/ProductList'
// import AppUsers from './Users/AppUsers'
// import UserIssues from './Issues/UserIssues'
// import List from './Events/List'
// import { Dashboard } from './Dashboard/Dashboard'
// import Admin from './Admin/Admin'
// import Metadata from './Metadata/Metadata'
// import ArchivedUsers from './Users/ArchivedUsers'

// import QRAuth from '../Auth_QR_Web/QR_Auth'


// const Router = () => {

//     const user = localStorage.getItem('user')
//     const navigate = useNavigate()

//     useEffect(() => {
//     const user = localStorage.getItem('user');

//     if (!user) {
//         navigate('/');
//     } else {
//         if (window.location.pathname === '/') {
//             navigate('/home');
//         }
//     }
// }, [navigate]);

//     return (
//         <>
//             {!user ? (
//                 <Routes>
//                     <Route path="/" Component={Login} />
//                     <Route path='/Authenticatior' Component={QRAuth} />
//                 </Routes>
//             ) : (
//                 <Layout>
//                     <Routes>
//                         <Route path='/home' Component={Dashboard} />
//                         <Route path='/metadata' Component={Metadata} />
//                         <Route path='/products' Component={ProductList} />
//                         <Route path='/app-users' Component={AppUsers} />
//                         <Route path='/archived-users' Component={ArchivedUsers} />
//                         <Route path='/user-issues' Component={UserIssues} />
//                         <Route path='/events' Component={List} />
//                         <Route path='/admin-user' Component={Admin} />
//                         {/* <Route path='/Authenticatior' Component={QRAuth} /> */}

//                     </Routes>
//                 </Layout>
//             )}
//         </>
//     )
// }

// export default Router






//AUTHORIZED ROUTES DEMO APP CHANGES
import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import Layout from "../Components/Layout/Layout";
import Login from "./Login";
import ProductList from "./Product/ProductList";
import AppUsers from "./Users/AppUsers";
import UserIssues from "./Issues/UserIssues";
import List from "./Events/List";
import { Dashboard } from "./Dashboard/Dashboard";
import Admin from "./Admin/Admin";
import BankIntegration from "./BankIntegration/BankIntegration";
import Metadata from "./Metadata/Metadata";
import ArchivedUsers from "./Users/ArchivedUsers";


import QRAuth from "../Auth_QR_Web/QR_Auth";
import DEMO_SHOPING from "../Auth_QR_Web/DEMO_ECOM/demo_online_site";

// 🔐 Protected Route Wrapper
const ProtectedRoute = ({ children }) => {
    const user = localStorage.getItem("user");

    if (!user) {
        return <Navigate to="/" replace />;
    }

    return children;
};

const Router = () => {
    return (
        <Routes>
            {/* ✅ PUBLIC ROUTES */}
            <Route path="/" element={<Login />} />
            <Route path="/Authenticatior" element={<QRAuth />} />
            <Route path="/Authentication" element={<QRAuth />} />
            <Route path="/shop" element={<DEMO_SHOPING />} />

            {/* ✅ PROTECTED ROUTES */}
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="home" element={<Dashboard />} />
                <Route path="metadata" element={<Metadata />} />
                <Route path="products" element={<ProductList />} />
                <Route path="app-users" element={<AppUsers />} />
                <Route path="archived-users" element={<ArchivedUsers />} />
                <Route path="user-issues" element={<UserIssues />} />
                <Route path="events" element={<List />} />
                <Route path="admin-user" element={<Admin />} />
                <Route path="bank-integration" element={<BankIntegration />} />
            </Route>

            {/* ✅ FALLBACK */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default Router;